// extracted by mini-css-extract-plugin
export var after = "style-module--after--73be7";
export var after__block = "style-module--after__block--b4cd3";
export var after__blockSec = "style-module--after__block--sec--b78eb";
export var after__btn = "style-module--after__btn--4d462";
export var after__img = "style-module--after__img--2c8c6";
export var after__infoBlock = "style-module--after__info-block--59b3a";
export var after__item = "style-module--after__item--6d76c";
export var after__itemDescr = "style-module--after__item-descr--b2dd1";
export var after__title = "style-module--after__title--2d92f";